export const partialAboutUrl = '/public';
